<template>
  <span
    class="oct-chip-set"
    role="grid"
  >
    <span
      class="oct-chip-set__item"
      v-for="(item, i) in items"
      :key="i"
    >
      <slot name="chip" v-bind:item="item"></slot>
    </span>
  </span>
</template>

<script>
export default {
  name: 'OctChipSet',
  props: {
    /** Chips */
    items: {
      type: Array,
      default () {
        return []
      }
    },
  }
}
</script>

<style scoped lang="scss">
@import "../theme/variables";
@import "../grid/variables";
@import "../typography/variables";
@import "../typography/mixins";

.oct-chip-set {
  margin: -3px -4px -3px -3px;
  display: flex;
  flex-wrap: wrap;

  &--collapse {
    &[aria-expanded="false"] {
      max-height: 100px+6;
      overflow: hidden;
    }
  }

}

.oct-chip-set__item {
  padding: 3px 4px 3px 3px;
}
</style>
